// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d7679b9d","111":"56816222","496":"aa6fc083","520":"92462205","903":"1f47faf9","942":"3d9ff897","997":"93798bc5"}[chunkId] + ".chunk.js";
};